import React from 'react';

const PhoneControlsActionContainerButtonDivider = () => {
  return <div className="phoneControlsActionContainer-buttonDivider" />;
};

export default PhoneControlsActionContainerButtonDivider;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/phone_controls/lib/phone_controls_action_container_button_divider.jsx